/*
  PLP swipe-galleri runtime. Ingen bibliotek. Opgaver:
   1) GALLERI LOADER MED KORTET (som DBS): slide 2+ har ingen src i markup. Naar et kort naermer sig
      viewport (IO, ~1,5 skaerm frem), saettes src paa ALLE kortets slides paa lav prioritet og
      billederne decodes. Naar brugeren swiper, ligger billedet allerede klar -> intet blankt/pop.
      LCP-beskyttelse: intet galleri-load foer window.load. Kun mobil (desktop swiper ikke) og ikke
      ved Spar data. Fallback: on-swipe (IO i scrolleren) + warm-on-touch, som foer.
   2) MARKER (DISKRET): thumb flytter sig til det AKTIVE billedes plads - translateX(idx*100%) -
      og en CSS-transition (i collection-grid) glider den paa plads. Vi aflaeser KUN det snappede
      indeks (round(scrollLeft/clientWidth)), ikke scrollLeft hver frame -> kan ikke jittre
      (heller ikke iOS 26 Safari).
   3) BFCACHE: ved back/forward-gendannelse reloades evt. brudte billeder.
  Selv-guard: koerer kun én gang pr. side.
*/
(function () {
  if (window.__pitPlpSwipe) return;
  window.__pitPlpSwipe = true;

  var RAF = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
  var warmed = {};

  function warm(img) {
    if (!img || !img.dataset.src) return;
    var key = img.dataset.srcset || img.dataset.src;
    if (warmed[key]) return; warmed[key] = 1;
    var w = new Image();
    if (img.dataset.srcset) { w.srcset = img.dataset.srcset; w.sizes = img.getAttribute('sizes') || ''; }
    w.src = img.dataset.src;
  }
  function markLoaded(img) { img.classList.add('pit-loaded'); }   // udloeser fade-in (CSS)
  function afterLoad(img) {
    // Decode foer vi viser: iOS Safari decoder ellers foerst ved foerste paint -> kort blank ved swipe.
    if (img.decode) img.decode().then(function () { markLoaded(img); }, function () { markLoaded(img); });
    else markLoaded(img);
  }
  function show(img) {
    if (!img) return;
    if (!img.__ld) {
      img.__ld = 1;
      img.addEventListener('load', function () { afterLoad(img); }, { once: true });
      img.addEventListener('error', function () { markLoaded(img); }, { once: true });
    }
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
    if (img.complete && img.naturalWidth > 0) afterLoad(img);   // allerede i cache
  }
  function curIdx(s) { return s.clientWidth ? Math.round(s.scrollLeft / s.clientWidth) : 0; }
  function warmAround(s, idx) {
    var k = s.children;
    for (var i = idx; i <= idx + 1 && i < k.length; i++) {
      var im = k[i].querySelector && k[i].querySelector('img.pit-defer');
      if (im) warm(im);
    }
  }

  function onDown(e) {
    var t = e.target, s = t && t.closest ? t.closest('.pit-swipe') : null;
    if (s) { if (eagerAllowed()) loadCard(s); warmAround(s, curIdx(s) + 1); }   // Spar data: kun naeste slide
  }
  document.addEventListener('pointerdown', onDown, true);
  document.addEventListener('touchstart', onDown, { capture: true, passive: true });

  // ---- DISKRET MARKER: saet thumb til det snappede indeks; CSS-transition glider den ----
  function setThumb(s) {
    var n = s.children.length; if (n <= 1) return;
    var th = s.parentNode && s.parentNode.querySelector('.pit-thumb'); if (!th) return;
    var idx = curIdx(s);
    if (idx < 0) idx = 0; else if (idx > n - 1) idx = n - 1;
    if (s.__idx === idx) return;            // uaendret -> roer ikke transform (ingen re-trigger)
    s.__idx = idx;
    th.style.transform = 'translateX(' + (idx * 100) + '%)';
  }

  function onScroll(e) {
    var s = e.target;
    if (!s || s.nodeType !== 1 || !s.classList || !s.classList.contains('pit-swipe')) return;
    if (!s.__pw) {
      s.__pw = true;
      RAF(function () { s.__pw = false; warmAround(s, curIdx(s) + 1); setThumb(s); });
    }
  }
  document.addEventListener('scroll', onScroll, true);
  document.addEventListener('scrollend', function (e) {
    var s = e.target;
    if (s && s.classList && s.classList.contains('pit-swipe')) setThumb(s);
  }, true);

  // ---- FALLBACK: on-swipe (slide bliver synlig i scrolleren) ----
  function setupLazy(s) {
    if (s.__pitLazy) return;
    s.__pitLazy = true;
    var d = s.querySelectorAll('img.pit-defer');
    if (!d.length) return;
    if (!('IntersectionObserver' in window)) { for (var j = 0; j < d.length; j++) show(d[j]); return; }
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { show(es[i].target); io.unobserve(es[i].target); } }
    }, { root: s, rootMargin: '0px 0px 0px 0px', threshold: 0.01 });
    for (var k = 0; k < d.length; k++) io.observe(d[k]);
  }

  // ---- GALLERI LOADER MED KORTET: KUN MED LEDIG BAANDBREDDE ----
  // Maalt 2/10-2026 (Chromium 4G 9 Mbit/s, hurtig scroll; WebKit 26 varm/kold):
  //  - Forhaandshentning uden styring (ogsaa native loading=lazy) lod hovedbilleder vente op til 4,2 s
  //    mod 0,8 s i dag. Galleriet maa derfor kun bruge baandbredde hovedbillederne ikke skal bruge:
  //    PORT 1: intet nyt galleri-load mens et hovedbillede i/lige under skaermen mangler
  //    PORT 2: intet nyt galleri-load mens siden scrolles lodret (man swiper ikke imens)
  //  - Naar brugeren stopper: synlige kort goeres helt faerdige (slide 2-4) foerst, saa naermeste kort.
  //  - MAX 4 samtidige: kold CDN-generering er serverventetid, ikke baandbredde.
  var MAX = 4, inflight = 0, cand = [];
  function loadCard(s) {                       // brugerintention (touch): hele kortet straks, uden koe
    if (s.__full) return; s.__full = 1;
    var d = s.querySelectorAll('img.pit-defer');
    for (var i = 0; i < d.length; i++) {
      d[i].setAttribute('fetchpriority', 'low');
      d[i].setAttribute('loading', 'eager');   // vandrette slides udskydes ellers af native lazy
      show(d[i]);
    }
  }
  function ready(im) { return !im || im.complete; }          // loadet ELLER fejlet: en fejl laaser ikke koeen
  function slide1(s) { var c = s.children[0]; return c && c.querySelector('img'); }
  // 3 s loft pr. hovedbillede, saa et billede browseren endnu ikke har bestilt ikke blokerer for evigt
  var pend = typeof WeakMap === 'function' ? new WeakMap() : null;
  function slide1Pending() {
    var vh = window.innerHeight, now = Date.now(), l = document.querySelectorAll('.pit-swipe');
    for (var i = 0; i < l.length; i++) {
      var r = l[i].getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= vh * 1.5) continue;
      var im = slide1(l[i]); if (ready(im)) continue;
      if (!pend) return true;
      var t0 = pend.get(im); if (!t0) { pend.set(im, now); t0 = now; }
      if (now - t0 < 3000) return true;
    }
    return false;
  }
  function pickNext() {
    var vh = window.innerHeight, best = null, bestKey = 1e9;
    for (var i = cand.length - 1; i >= 0; i--) {
      var s = cand[i];
      if (s.__full || s.isConnected === false) { cand.splice(i, 1); continue; }
      var im = s.querySelector('img.pit-defer:not([src])');
      if (!im) { s.__full = 1; cand.splice(i, 1); continue; }
      if (!ready(slide1(s))) continue;                       // kortets eget hovedbillede foerst
      var r = s.getBoundingClientRect();
      var dist = r.bottom < 0 ? -r.bottom : (r.top > vh ? r.top - vh : 0);
      if (dist > 2500) continue;                             // langt vaek: vent til brugeren naermer sig
      var idx = Array.prototype.indexOf.call(s.children, im.closest('.pit-slide'));
      var key = dist === 0
        ? (idx - 1) * 0.6 + Math.max(0, r.top) / vh          // synligt kort: alle slides, oeverst foerst
        : 2 + dist / vh + (idx - 1);                         // uden for skaermen: slide 2 foerst, naermest foerst
      if (key < bestKey) { bestKey = key; best = im; }
    }
    return best;
  }
  var pumpQ = false, scrolling = false, scT = null, retryT = null;
  // Tryk paa et link der forlader siden (fx produktet): galleri-billeder der stadig hentes afbrydes, saa
  // de ikke konkurrerer med naeste side (maalt 3/10-2026: PDP +0,2 s paa langsomt net uden dette).
  // Lytter i bubble-fasen paa window, saa temaets egne klik (AJAX-sideskift, filtre, wishlist) har
  // kaldt preventDefault foerst og ikke udloeser afbrydelse. Sikkerhedsnet: genoptag efter 4 s, hvis
  // siden ikke blev forladt alligevel. Afbrudte billeder hentes igen ved tilbage (bfcache).
  var leaving = false, leaveT = null;
  function resumeGallery() {
    clearTimeout(leaveT); leaving = false;
    var ab = document.querySelectorAll('.pit-swipe img.pit-defer:not([src])');
    for (var j = 0; j < ab.length; j++) if (ab[j].__aborted) { ab[j].__aborted = 0; show(ab[j]); }
    pump();
  }
  function abortGallery() {
    leaving = true; clearTimeout(leaveT); leaveT = setTimeout(resumeGallery, 4000);
    var l = document.querySelectorAll('.pit-swipe img.pit-defer[src]');
    for (var i = 0; i < l.length; i++) {
      var im = l[i]; if (im.complete) continue;
      if (im.getAttribute('srcset')) im.setAttribute('data-srcset', im.getAttribute('srcset'));
      im.setAttribute('data-src', im.getAttribute('src'));
      im.removeAttribute('srcset'); im.removeAttribute('src'); im.__aborted = 1;
      im.dispatchEvent(new Event('error'));   // frigiver koe-pladsen med det samme
    }
  }
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    var h = a.getAttribute('href') || '';
    if (!h || h.charAt(0) === '#' || /^(javascript|mailto|tel|sms):/i.test(h)) return;
    abortGallery();
  }, false);
  function pump() {
    if (pumpQ) return; pumpQ = true;
    RAF(function () {
      pumpQ = false;
      if (!pageLoaded || leaving || inflight >= MAX || !cand.length || scrolling) return;
      if (slide1Pending()) {                                 // genoptages ved load-event, eller efter 3 s-loftet
        clearTimeout(retryT); retryT = setTimeout(pump, 500); return;
      }
      while (inflight < MAX) {
        var im = pickNext(); if (!im) return;
        if (!im.dataset.src) { im.classList.remove('pit-defer'); continue; }   // tom data-src: spring over
        inflight++;
        (function (im) {
          var fin = 0, t = setTimeout(done, 10000);          // vagt: taelleren kan aldrig haenge
          function done() { if (fin) return; fin = 1; clearTimeout(t); inflight--; pump(); }
          im.addEventListener('load', done, { once: true });
          im.addEventListener('error', done, { once: true });
          im.setAttribute('fetchpriority', 'low');
          im.setAttribute('loading', 'eager');
          show(im);
        })(im);
      }
    });
  }
  // ethvert billede der loader (fx et hovedbillede) kan aabne koeen igen. load bobler ikke -> capture.
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG' && cand.length) pump(); }, true);
  window.addEventListener('scroll', function () {
    scrolling = true; clearTimeout(scT);
    scT = setTimeout(function () { scrolling = false; pump(); }, 200);
  }, { passive: true });

  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  function eagerAllowed() {
    if (mq && !mq.matches) return false;                                   // desktop swiper ikke
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return false; // Spar data / 2G
    return true;
  }
  var pageLoaded = document.readyState === 'complete';
  window.addEventListener('load', function () { pageLoaded = true; pump(); });   // LCP foerst
  var cio = null;
  function setupCard(s) {
    if (s.__pc) return;
    if (!('IntersectionObserver' in window) || !eagerAllowed()) return;   // ikke markeret -> proeves igen ved rotation
    s.__pc = 1;
    if (!cio) {
      cio = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (!es[i].isIntersecting) continue;
          var sc = es[i].target; cio.unobserve(sc);
          if (cand.indexOf(sc) < 0) cand.push(sc);
        }
        pump();
      }, { root: null, rootMargin: '400px 0px 1300px 0px', threshold: 0 });
    }
    cio.observe(s);
  }

  // Rotation landskab -> portraet: kort der blev sprunget over (desktop-bredde) saettes op nu
  if (mq) { var onMq = function () { if (mq.matches) queueInit(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq); }

  var queued = false;
  function initAll() {
    queued = false;
    var l = document.querySelectorAll('.pit-swipe');
    for (var i = 0; i < l.length; i++) { setupLazy(l[i]); setupCard(l[i]); setThumb(l[i]); }
  }
  function queueInit() { if (!queued) { queued = true; RAF(initAll); } }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  if (window.MutationObserver && document.body) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var an = m[i].addedNodes;
        for (var j = 0; j < an.length; j++) {
          var n = an[j];
          if (n.nodeType === 1 && ((n.classList && n.classList.contains('pit-swipe')) || (n.querySelector && n.querySelector('.pit-swipe')))) { queueInit(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    resumeGallery();
    var imgs = document.querySelectorAll('.pit-swipe img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.getAttribute('src') && im.complete && im.naturalWidth === 0) {
        var s = im.getAttribute('src'); im.removeAttribute('src'); im.src = s;
      }
    }
    var sws = document.querySelectorAll('.pit-swipe');
    for (var k = 0; k < sws.length; k++) { sws[k].__idx = -1; setThumb(sws[k]); }
  });
})();
